import { Card, CardContent, CardHeader, Typography, TextField, Button, FormControl, InputLabel, Select, MenuItem, Alert, Box } from '@mui/material';
import { useState } from 'react';
import { addUsersByEmailToOrganization } from '../../services/organizationService';

export default function AddUserToOrganizationView({ onClose, organizationId }) {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async () => {
    if (!email.trim()) {
      setError('Please enter an email address');
      return;
    }

    setIsLoading(true);
    setError('');
    setSuccess('');

    try {
      await addUsersByEmailToOrganization({ emails: [email.trim()], organizationId: organizationId });
      setSuccess('User added successfully!');
      setEmail('');
      // Close modal after a short delay to show success message
      setTimeout(() => {
        if (onClose) onClose();
      }, 1500);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to add user. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    if (onClose) onClose();
  };

  return (
    <Card>
      <CardHeader title="Add User to Organization" />
      <CardContent>
        <Typography variant="body2" sx={{ mb: 3 }}>
          Enter the email address of the user you want to add to your organization.
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {success}
          </Alert>
        )}

        <TextField
          fullWidth
          label="Email Address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{ mb: 3 }}
          disabled={isLoading}
        />

        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="outlined"
            onClick={handleClose}
            disabled={isLoading}
            sx={{ flex: 1 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={isLoading}
            sx={{ flex: 1 }}
          >
            {isLoading ? 'Adding...' : 'Add User'}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}
